import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {storeFromArea} from '../../utils/index';
import {getStateProps, removeStateProps} from '../base/AbstractMap';
import {commonDefaultProps, commonPropTypes} from '../common/props';

import {
    setBackgroundLayer,
    setCatalogNodes,
    setFilter,
    setForegroundLayer,
    setLayers,
    setLocation,
    setTopic,
    setZoom
} from './AbstractMapActions';

import {geBaseAbstractMapArea} from './AbstractMapReducer';

/**
 * Předek pro mapové komponenty.
 */
export default class AbstractMap extends PureComponent {

    static propTypes = {
        ...commonPropTypes,
    };

    static defaultProps = {
        ...commonDefaultProps
    };

    handleTopicChange = topic => {
        const {dispatch, area} = this.props;
        dispatch(setTopic(area, topic));
    };

    handleBackgroundLayerChange = backgroundLayer => {
        const {dispatch, area} = this.props;
        dispatch(setBackgroundLayer(area, backgroundLayer));
    };

    handleForegroundLayerChange = foregroundLayer => {
        const {dispatch, area} = this.props;
        dispatch(setForegroundLayer(area, foregroundLayer));
    };

    handleLayersChange = layers => {
        const {dispatch, area} = this.props;
        dispatch(setLayers(area, layers));
    };

    handleCatalogNodesChange = catalogNodes => {
        const {dispatch, area} = this.props;
        dispatch(setCatalogNodes(area, catalogNodes));
    };

    handleLocationChange = location => {
        const {dispatch, area} = this.props;
        dispatch(setLocation(area, location));
    };

    handleZoomChange = zoom => {
        const {dispatch, area} = this.props;
        dispatch(setZoom(area, zoom));
    };

    handleFilterChange = filter => {
        const {dispatch, area} = this.props;
        dispatch(setFilter(area, filter));
    };

    getBaseAbstractMapProps() {
        const {area, ...otherProps} = this.props;

        return {
            ...otherProps,
            area: geBaseAbstractMapArea(area),
            onTopicChange: this.handleTopicChange,
            onBackgroundLayerChange: this.handleBackgroundLayerChange,
            onForegroundLayerChange: this.handleForegroundLayerChange,
            onLayersChange: this.handleLayersChange,
            onCatalogNodesChange: this.handleCatalogNodesChange,
            onLocationChange: this.handleLocationChange,
            onZoomChange: this.handleZoomChange,
            onFilterChange: this.handleFilterChange,
        }
    }
}

/**
 * Napojení do redux store pro potomky AbstractMap.
 */
export const connectAbstractMap = connect((state, props) => {
    return getStateProps(storeFromArea(state, props.area));
}, null, (stateProps, dispatchProps, ownProps) => {
    // Nechceme umožnit externě přepsat stavové props!
    return {...removeStateProps(ownProps), ...stateProps, ...dispatchProps};
});
